import { Component, Host, h, Prop, Watch } from '@stencil/core';

interface UiCmsNavigationSkiplinksBody {
  navigationId?: string;
  contentId?: string;
  excludeSearch: boolean;
}

@Component({
  tag: 'ui-cms-navigation-skiplinks',
  styleUrl: 'ui-cms-navigation-skiplinks.scss',
})
export class UiCmsNavigationSkiplinks {
  @Prop({ mutable: true }) body: UiCmsNavigationSkiplinksBody = {} as any;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Watch('utilityBody')
  utilityBodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  @Prop({ mutable: true }) i18n = { navigation: 'Navigation', content: 'Inhalt', search: 'Suche' };

  @Prop({ attribute: 'i18n' }) utilityI18n: string;

  @Watch('utilityI18n')
  utilityI18nChangeHandler(newValue: string) {
    if (newValue) this.i18n = { ...this.i18n, ...JSON.parse(newValue) };
  }

  componentWillLoad() {
    this.utilityBodyChangeHandler(this.utilityBody);
    this.utilityI18nChangeHandler(this.utilityI18n);
  }

  render() {
    return (
      <Host class="sd-hidden-links sd-hidden-links--multiple">
        {this.body.navigationId && (
          <sd-navigation-item href={this.body.navigationId} size="base">
            {this.i18n.navigation}
          </sd-navigation-item>
        )}
        {this.body.contentId && (
          <sd-navigation-item href={this.body.contentId} size="base">
            {this.i18n.content}
          </sd-navigation-item>
        )}
        {!this.body.excludeSearch && (
          <sd-navigation-item href="#global-search-trigger" size="base">
            {this.i18n.search}
          </sd-navigation-item>
        )}
      </Host>
    );
  }
}
